<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="3" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">能力测试报告</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji1"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi1">能力测试报告</div>
    </div>
    <div style="display: flex;">
      <div>
        <Header :activeIndex="3" v-if="!isMobile" />
      </div>
      <div>
        <div class="juzhong1">
          <div class="head01">
            <div class="beijing">
              <div class="biaoshi">
                <div class="xiangji"><i class="el-icon-s-opportunity"></i></div>
                <div class="mingqiceping">名企-学业性评测</div>
              </div>
              <div class="head02">
                <div class="head03">
                  <div class="headkuandu">
                    <div>
                      <PieChart id="myPie" v-bind="myPie" class="pie01" />
                    </div>
                    <div class="pie001">
                      <div class="pie002">评级</div>
                      <div class="shuangS">{{ pingji }}</div>
                    </div>
                  </div>
                  <div class="juzhong">
                    <div class="xueye">
                      <div class="biaoti1">得分是：{{ myPie.titleData.subtext }}分</div>
                      <div class="biaoti2">
                        <span class="large-dot"></span> {{ title }}
                      </div>
                      <div v-for="(item, index) in descs" :key="'jichu-' + index" class="biaoti2">
                        <span class="large-dot"></span>
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="beijing1">
              <div class="biaoshi">
                <div class="xiangji"><i class="el-icon-s-opportunity"></i></div>
                <div class="mingqiceping">名企-职业性评测</div>
              </div>
              <div style="display: flex; justify-content: space-around">
                <div class="head03">
                  <div>
                    <PieChart id="myPie1" v-bind="myPie1" class="pie02" />
                  </div>
                  <div class="juzhong">
                    <div class="zhiye">
                      <div v-for="(item, index) in jichuList" :key="'jichu-' + index" class="biaoti2">
                        <span class="large-dot"></span>
                        {{ item }}
                      </div>

                      <div v-for="(item, index) in descList" :key="'desc-' + index" class="biaoti3">
                        <span class="large-dot"></span>
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="juzhong">
            <div class="save" @click="goToUsereport">查看详细报告</div>
          </div>
        </div>
        <div class="zhiye01">
          <div class="zhiye02">推荐职业方向</div>
          <div class="zhiye03">
            <div v-for="(position, index) in positions" :key="index" class="zhiwei">
              <div class="demo-type">
                <div>
                  <el-avatar icon="el-icon-user-solid"></el-avatar>
                </div>
              </div>
              <div class="zhiye04">
                <div>职位名称：{{ position.name }}</div>
                <div>所属行业：{{ position.industry }}行业</div>
                <div>匹配度：{{ position.matchRate }}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import PieChart from "@/components/PieChart";
import Header from "./Header.vue";
import Footer from './Footer.vue'
export default {
  name: "researchrep",
  components: { PieChart, Header, Footer },
  data() {
    return {
      myPie: {
        isRing: true,
        chartStyle: {
          height: "220px",
        },
        titleData: {
          subtext: 0,
          text: "得分",
        },
        colors: ["#169BFA", "#FBAD3B", "#31CF9A", "#E87A4B", "#6A8DFF"],
        legendData: [
          { data: ["学历", "学校排名", "获奖情况与证书", "学习成绩", "成绩排名"] },
        ],
        seriesData: [
          {
            data: [
              { name: "学历", value: 20 },
              { name: "学校排名", value: 16 },
              { name: "获奖情况与证书", value: 10 },
              { name: "学习成绩", value: 18 },
              { name: "成绩排名", value: 19 },
            ],
          },
        ],
        hasPieLabel: false,
      },
      myPie1: {
        isRing: true,
        chartStyle: {
          height: "220px",
        },
        titleData: {
          subtext: "",
          text: "职业性测评",
        },
        colors: ["#169BFA", "#31CF9A", "#9B59B6", "#FBAD3B", "#E87A4B", "#F4D03F"],
        legendData: [
          { data: ["常规型C", "现实型R", "研究型I", "管理型E", "社会型S", "艺术型A"] },
        ],
        seriesData: [
          {
            data: [
              { name: "常规型C", value: 70 },
              { name: "现实型R", value: 52 },
              { name: "研究型I", value: 80 },
              { name: "管理型E", value: 40 },
              { name: "社会型S", value: 65 },
              { name: "艺术型A", value: 35 },
            ],
          },
        ],
        hasPieLabel: false,
      },
      userId: sessionStorage.getItem("userId"),
      BASE_URL: "https://zhiyedashi.com/career",
      BASE_URL1: "https://zhiyedashi.com/info",
      BASE_URL2: "https://zhiyedashi.com/school",
      BASE_URL3: "https://zhiyedashi.com/job",
      BASE_URL5: "https://zhiyedashi.com/match",
      // BASE_URL: "http://192.168.2.8:8203",
      // BASE_URL1: "http://192.168.2.8:8206",
      // BASE_URL2: "http://192.168.2.8:8205",
      // BASE_URL3: "http://192.168.2.8:8204",
      jichuList: [],
      descList: [],
      pingji: "",
      academicId: 0,
      descs: [],
      title: "",
      form: {
        applicants: [],
        jobs: [],
      },
      newApplicant: {
        applicant: "",
        education: "",
        major: "",
        school_rank: null,
        certificates: [],
        intern_experience: [],
        holland_result: "",
        expected_salary: "面议",
      },
      positions: [],
      gangwei: [],
      isMobile: false
    };
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.userId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.scoreresult();
    this.pipei();
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    jobs(major) {
      fetch(`${this.BASE_URL3}/admin/jobliebiao/selectByMajor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `major=${major}`,
      })
        .then((res) => res.json())
        .then((data) => {
          this.gangwei = data;
          this.matchingResults = data.map((item) => item.jobId)
          localStorage.setItem("matchingResults", JSON.stringify(this.matchingResults));

          // this.form.jobs = data.map((item) => item.jobName);
          // 先把 form.jobs都分成200份
          const allJobs = data.map((item) => item.jobName)
          const allTopPostions = []
          let fetchPromises = [];

          for (let i = 0; i < allJobs.length; i += 25) {
            this.form.jobs = allJobs.slice(i, i + 25);

            let fetchPromise = fetch(`${this.BASE_URL3}/admin/proxy`, {
              method: "post",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: `targetUrl=${this.BASE_URL5}&textent=${JSON.stringify(this.form)}`,
            })
              .then((res) => res.json())
              .then((data) => {
                const topThreePositions = data.results
                  .map((position) => ({
                    ...position,
                    matchRate: parseFloat(
                      position.Comprehensive_matching_score.split("/")[0]
                    ),
                  }))
                  .sort((a, b) => b.matchRate - a.matchRate) // 按 matchRate 降序排序
                  .reduce((uniquePositions, position) => {
                    // 检查当前 position.name 是否已经存在于 uniquePositions 中
                    if (!uniquePositions.some(p => p.name === position.job)) {
                      uniquePositions.push({
                        name: position.job,
                        industry: position.industry,
                        matchRate: position.matchRate,
                      });
                    }
                    return uniquePositions;
                  }, []) // 使用 reduce 来去重并收集前 10 个不同的职位
                  .slice(0, 2);
                allTopPostions.push(...topThreePositions);
              })
              .catch((error) => {
                console.error("匹配职业失败，原因是", error);
              });

            fetchPromises.push(fetchPromise);
          }

          Promise.all(fetchPromises)
            .then(() => {
              const uniqueTopPositions = allTopPostions.reduce((uniquePositions, position) => {
                if (!uniquePositions.some(p => p.name === position.name)) {
                  uniquePositions.push(position);
                }
                return uniquePositions;
              }, []);
              const result = uniqueTopPositions
                .sort((a, b) => b.matchRate - a.matchRate)
                .slice(0, 3);

              // 2. 赋值给 `positions`（在 Vue 中可能是 `this.positions`）
              this.positions = result;
              const updatedPositions = this.positions.map((position) => {
                // 在 DATA 中查找匹配的 jobName
                const matchedJob = this.gangwei.find(
                  (item) => item.jobName === position.name
                );

                // 返回新的对象，补全 industry
                return {
                  ...position,
                  industry: matchedJob ? matchedJob.industryName : "未知行业", // 如果没找到，默认"未知行业"
                };
              });
              this.positions = updatedPositions;
            })
            .catch((error) => {
              console.error("Error in fetching jobs:", error);
            });
        })
        .catch((error) => {
          console.error("用户信息查询失败，原因是", error);
        });
    },
    pipei() {
      // 根据userId查询对应的专业  信息表，
      fetch(`${this.BASE_URL1}/admin/resumes/selectResumes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `userId=${this.userId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          const applicant = {
            applicant: data.data.userName,
            education: data.data.degree,
            major: data.data.major,
            certificates: JSON.parse(data.data.certificate),
            intern_experience: JSON.parse(data.data.internship),
            holland_result: this.myPie1.titleData.subtext,
            expected_salary: "6000-8000",
          };

          // 直接 push 新对象到数组
          this.form.applicants.push(applicant);

          // 如果需要更新 form.applicants
          this.form.applicants = this.form.applicants;
          this.jobs(data.data.major);
        })
        .catch((error) => {
          console.error("用户信息查询失败，原因是", error);
        });
    },
    selectacademic() {
      if (this.myPie.titleData.subtext <= 70) {
        this.academicId = 1;
      } else if (
        this.myPie.titleData.subtext > 70 &&
        this.myPie.titleData.subtext <= 75
      ) {
        this.academicId = 2;
      } else if (
        this.myPie.titleData.subtext > 75 &&
        this.myPie.titleData.subtext <= 80
      ) {
        this.academicId = 3;
      } else if (
        this.myPie.titleData.subtext > 80 &&
        this.myPie.titleData.subtext <= 85
      ) {
        this.academicId = 4;
      } else if (
        this.myPie.titleData.subtext > 85 &&
        this.myPie.titleData.subtext <= 90
      ) {
        this.academicId = 5;
      } else if (
        this.myPie.titleData.subtext > 90 &&
        this.myPie.titleData.subtext <= 100
      ) {
        this.academicId = 6;
      }
      localStorage.setItem("academicId", this.academicId);
      fetch(`${this.BASE_URL2}/admin/Academic/selectAcademic`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `academicId=${this.academicId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          let jsonData = JSON.parse(data.data.description);
          this.title = jsonData.title;
          this.descs = jsonData.desc;
        })
        .catch((error) => {
          console.error("查询学业描述失败，原因是", error);
        });
    },
    scoreresult() {
      fetch(`${this.BASE_URL1}/admin/score`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `userId=${this.userId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log("学业成绩data", data);
          if (data.data === '暂无数据') {
            alert("请先填写学业信息")
            this.$router.push('/personalInf');
          } else {
            this.careerresult();
            const apiData = data.data;

            // 2. 定义映射关系（API 字段 → name）
            const fieldMapping = {
              xueli: "学历",
              xuexiaopm: "学校排名",
              huojiang: "获奖情况与证书",
              chengji: "学习成绩",
              chengjipm: "成绩排名",
            };

            // 3. 遍历 seriesData[0].data 并更新 value
            this.myPie.seriesData[0].data.forEach((item) => {
              // 找到当前 item.name 对应的 API 字段
              const apiField = Object.keys(fieldMapping).find(
                (key) => fieldMapping[key] === item.name
              );

              // 如果找到对应字段，则更新 value
              if (apiField && apiData[apiField] !== undefined) {
                item.value = apiData[apiField];
              }
            });

            this.myPie.titleData.subtext = this.myPie.seriesData[0].data.reduce(
              (sum, item) => {
                return sum + item.value;
              },
              0
            ); // 初始值为 0

            this.selectacademic();

            if (this.myPie.titleData.subtext >= 90) {
              this.pingji = "SSS";
            } else if (this.myPie.titleData.subtext >= 85) {
              this.pingji = "SS";
            } else if (this.myPie.titleData.subtext >= 80) {
              this.pingji = "S";
            } else if (this.myPie.titleData.subtext >= 75) {
              this.pingji = "A";
            } else if (this.myPie.titleData.subtext >= 0) {
              this.pingji = "B";
            }
          }
        })
        .catch((error) => {
          console.error("查询描述失败，原因是", error);
        });
    },
    goToUsereport() {
      this.$router.push("/usereport");
    },
    selectDesc() {
      fetch(`${this.BASE_URL}/admin/type/desc/selectDesc`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `code=${this.myPie1.titleData.subtext}`,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          this.jichuList = data.data.jichu;
          this.descList = data.data.desc;
        })
        .catch((error) => {
          console.error("查询描述失败，原因是", error);
        });
    },
    careerresult() {
      fetch(`${this.BASE_URL}/admin/career/result/selectUserId`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `userId=${this.userId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.data === '暂无测试数据') {
            alert("请先填写测试问题")
            this.$router.push('/CareerQuiz');
          } else {
            this.myPie1.titleData.subtext = data.data[0].result;
            const typeScoreStr = data.data[0].typeScore;
            const typeNames = {
              A: "艺术型A",
              C: "常规型C",
              E: "管理型E",
              I: "研究型I",
              R: "现实型R",
              S: "社会型S",
            };

            // 2. 解析字符串并生成 seriesData
            const seriesData = typeScoreStr.split(";").map((pair) => {
              const [code, value] = pair.split(":");
              return {
                name: typeNames[code],
                value: parseInt(value) * 10, // 按需调整计算逻辑（如 *10 或其他）
              };
            });

            // 3. 更新 myPie1 的 seriesData
            this.myPie1 = {
              ...this.myPie1, // 保留其他配置
              seriesData: [{ data: seriesData }], // 格式：seriesData 是数组，内部是对象，对象包含 data 数组
            };
            this.selectDesc();
          }
        })
        .catch((error) => {
          console.error("查询失败，原因是", error);
        });
    },
  },
};
</script>
<style scoped>
.large-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: white;
  margin-right: 5px;
}

.beijing {
  background-color: #5c8bfd;
  height: 630px;
  width: 650px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
}

.beijing1 {
  background-color: rgb(92, 170, 137);
  height: 630px;
  width: 650px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
}

.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji1 {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.xiangji21 {
  font-weight: 900;
  font-size: 155px;
  border: 1px soild #dcdfe6;
}

.gerenxinxi1 {
  margin-left: 20px;
  font-weight: 700;
}

.biaoshi {
  height: 50px;
  width: 100%;
  border-bottom: 1px solid white;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.mingqiceping {
  margin-left: 20px;
  font-weight: 700;
}

.xueye {
  width: 540px;
  height: 320px;
  color: white;
  border: 3px solid white;
  border-radius: 30px;
  text-align: left;
  margin-top: -30px;
}

.zhiye {
  width: 540px;
  height: 320px;
  color: white;
  border-radius: 30px;
  text-align: left;
  border: 3px solid white;
  margin-top: -30px;
}

.shuangS {
  font-size: 52px;
  font-weight: 700;
  margin-left: 15px;
  letter-spacing: -5px;
  text-transform: uppercase;
  transform: scaleY(2);
  display: inline-block;
  line-height: 173px;
}

.biaoti1 {
  font-size: 25px;
  font-weight: 700;
  margin-left: 25px;
  margin-top: 15px;
}

.biaoti2 {
  font-size: 16px;
  margin-left: 25px;
  margin-top: 15px;
}

.biaoti3 {
  margin-left: 25px;
  margin-top: 15px;
  margin-right: 5px;
}

.zhiwei {
  height: 150px;
  width: 350px;
  border: 1px solid #dcdfe6;
  border-radius: 20px;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.juzhong {
  display: flex;
  justify-content: center;
  align-items: center;
}

.juzhong1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 30px;
  flex-direction: column;
  margin-top: 15px
}

.head01 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  gap: 50px;
}

.head02 {
  display: flex;
  justify-content: space-around;
}

.head03 {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-top: 20px;
}

.headkuandu {
  display: flex;
  justify-content: center;
  align-items: center
}

.pie01 {
  width: 500px;
  margin-left: -40px;
}

.pie02 {
  width: 100%;
}

.pie001 {
  color: white;
  width: 150px;
  margin-left: -30px;
}

.pie002 {
  margin-top: -30px
}

.save {
  background-color: #488af8;
  color: #fff;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 15px;
  cursor: pointer;
}

.zhiye01 {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  text-align: left;
  margin-bottom: 70px;
}

.zhiye02 {
  font-size: 22px;
  font-weight: 700
}

.zhiye03 {
  display: flex;
  margin-top: 15px;
  width: 100%;
  justify-content: space-between;
}

.zhiye04 {
  width: 230px;
}

@media (max-width: 768px) {
  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
    position: static;
    margin-top: 0px;
  }

  .large-dot {
    width: 6px;
    height: 6px;
    margin-right: 3px;
  }

  .beijing {
    height: auto;
    width: 97%;
    border-radius: 20px;
    padding-bottom: 20px;
  }

  .beijing1 {
    height: auto;
    width: 97%;
    border-radius: 20px;
    padding-bottom: 20px;
  }

  .biaoshi {
    height: 40px;
  }

  .mingqiceping {
    margin-left: 15px;
  }

  .xueye,
  .zhiye {
    width: 80%;
    height: auto;
    margin-top: -20px;
    padding: 15px 0;
  }

  .shuangS {
    font-size: 35px;
    line-height: 120px;
    margin-left: 10px;
  }

  .biaoti1 {
    font-size: 20px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .biaoti2 {
    font-size: 14px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .biaoti3 {
    font-size: 14px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .zhiwei {
    height: auto;
    width: 90%;
    padding: 15px 0;
    gap: 15px;
  }

  .juzhong1 {
    margin-left: 0px;
    margin-top: 10px;
    width: 100%;
  }

  .head01 {
    padding-top: 140px;
    gap: 20px;
    flex-wrap: wrap;
  }

  .head03 {
    margin-top: 15px;
  }

  .pie01 {
    width: 300px;
    margin-left: -40px;
  }

  .pie02 {
    width: 400px;
    margin-left: -40px;
  }

  .pie001 {
    color: white;
    width: 104px;
  }

  .headkuandu {
    display: flex;
    /* justify-content: center; */
    justify-content: space-around;
    align-items: center
  }

  .save {
    height: 35px;
    width: 150px;
    border-radius: 8px;
    margin-left: 10px;
  }

  .zhiye01 {
    width: 95%;
    margin-top: 30px;
    margin-bottom: 40px;
  }

  .zhiye02 {
    font-size: 18px;
  }

  .zhiye03 {
    flex-direction: column;
    gap: 15px;
  }

  .zhiye04 {
    width: 100%;
  }

  .logo {
    width: 50px;
  }

  .demo-type {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/researchrep.vue